// Module
var code = "<template> <router-view></router-view> </template> ";
// Exports
module.exports = code;